import { render, staticRenderFns } from "./requisitionedDetail.vue?vue&type=template&id=3899f582&scoped=true"
import script from "./requisitionedDetail.vue?vue&type=script&lang=js"
export * from "./requisitionedDetail.vue?vue&type=script&lang=js"
import style0 from "./requisitionedDetail.vue?vue&type=style&index=0&id=3899f582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3899f582",
  null
  
)

export default component.exports